import {SORTABLE_POSITION} from '../../constants';

import type {SortablePosition} from '../../typedef';


const stepIndex = 1;

export const shouldSorting = (dragIndex: number, targetIndex: number, position: SortablePosition): boolean => {
    if (dragIndex === targetIndex || targetIndex < 0) {
        return false;
    }

    if (dragIndex === targetIndex - stepIndex && position === SORTABLE_POSITION.BEFORE) {
        return false;
    }

    return !(dragIndex === targetIndex + stepIndex && position === SORTABLE_POSITION.AFTER);
};
